export default "__VITE_ASSET__ko_RSCar__"